// V71 — Dashboard widget → gereken yetki (modül, eylem). Dashboard.js'teki hasPermission
// kapılarıyla aynı tutulur; DashboardManagement önizlemesi ve MyDashboardSettings listesi
// bu tek haritayı kullanır. Haritada olmayan widget herkese açıktır. Değer [[m,a],[m,a]] ise anyOf.
export const WIDGET_PERM = {
  summary_marketing: ['marketing', 'view'],
  summary_hotels: ['hotel_rates', 'view'],
  summary_freenights: ['free_nights', 'view'],
  summary_visas: ['visas', 'view'],
  summary_card_transactions: ['card_transactions', 'view'],
  checkin_widget: [['checkin', 'view'], ['tickets', 'view']], // backend checkins.js: checkin|tickets
  expiring_tickets: ['tickets', 'view'],
  passport_expiring: ['customers', 'view'],
  todays_payments: ['payments', 'view'],
  otp_feed_mini: ['otp_feed_widget', 'view'],
};

// Katalogda olup Dashboard'da hiç çizilmeyen widget'lar (uyarılar bildirim zilinde) — ayar ekranlarında gizlenir
export const HIDDEN_WIDGETS = new Set(['alerts']);

export const widgetReqs = (need) => (Array.isArray(need[0]) ? need : [need]);

export const canUseWidget = (key, hasPermission) => {
  if (HIDDEN_WIDGETS.has(key)) return false;
  const need = WIDGET_PERM[key];
  if (!need) return true;
  return widgetReqs(need).some(([m, a]) => !!hasPermission(m, a));
};

// Görünen alt küme içinde bir widget'ı yukarı/aşağı taşır; gizli öğelerin kayıttaki yeri korunur
export const moveAmongVisible = (config, key, dir, isShown) => {
  const idx = config.findIndex(c => c.key === key);
  if (idx < 0) return config;
  let t = idx + dir;
  while (t >= 0 && t < config.length && !isShown(config[t].key)) t += dir;
  if (t < 0 || t >= config.length) return config;
  const arr = [...config];
  [arr[idx], arr[t]] = [arr[t], arr[idx]];
  return arr.map((c, i) => ({ ...c, order: i }));
};
